// import { createRootRoute, Outlet } from '@tanstack/react-router'

// export const Route = createRootRoute({
//   component: () => (
//     <div>
//       <Outlet />
//     </div>
//   ),
// })
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TooltipProvider } from '@/components/ui/tooltip'

export const Route = createRootRoute({
  component: RootLayout,
})

function RootLayout() {
  return (
    <TooltipProvider delayDuration={0}>
      <div className="min-h-screen bg-background">
        <Outlet />
      </div>
    </TooltipProvider>
  )
}


// ```tsx title="app/layout.tsx"
// import { TooltipProvider } from "@/components/ui/tooltip"

// export default function RootLayout({ children }: { children: React.ReactNode }) {
//   return (
//     <html lang="en">
//       <body>
//         <TooltipProvider>{children}</TooltipProvider>
//       </body>
//     </html>
//   )
// }
// ```